<template>
  <InsightsEventsTable
    class="activityLogTable"
    :columns="columns"
    :isRefreshing="false"
    :loadingAdditionalData="false"
    :moreToLoad="false"
    :tableData="tableData"
  />
</template>
<script>

import { mapActions } from 'vuex';
import { quickPicksOptions } from 'client/Insights/ActivityLog/constants/QuickPicksConsts';
import EventMetadata, { eventFields, formatEventValue } from 'client/Insights/ActivityLog/constants/EventMetadata';
import InsightsAccessMixin from 'client/Insights/InsightsAccessMixin';
import InsightsEventsTable from 'client/Insights/ActivityLog/InsightsEventsTable.vue';
import Util from 'client/util/Util';

const defaultColumnNames = [
  eventFields.timestamp,
  eventFields.eventType,
  eventFields.result,
  eventFields.initiatedBy,
  eventFields.clientIp,
];

const insightsEventModule = 'InsightsEventModule';

export default {
  name: 'PasswordManagerActivityLogs',

  components: {
    InsightsEventsTable,
  },

  mixins: [InsightsAccessMixin],

  props: {
    // activity logs filters from EventMetadata
    apiFilters: {
      type: Array,
      default: () => [],
    },

    dropdownFilters: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tableData: [],
    };
  },

  computed: {
    columns() {
      // Make sure we're showing '-' if no data
      return defaultColumnNames.map((columnName) => {
        const column = EventMetadata[columnName];
        return {
          ...column,
          getDataValue: data => formatEventValue(column.getDataValue(data)),
        };
      });
    },
  },

  created() {
    this.getLastEventsList(10, ['password_manager'], this.apiFilters)
      .then((response) => {
        this.tableData = response.data;
      });
  },

  methods: {
    ...mapActions(insightsEventModule, [
      'clearFilters',
      'setFilter',
      'setQuickPickDate',
    ]),

    redirectToDirectoryInsights() {
      // Clear any existing Activity Log filters
      this.clearFilters();

      // Set the time range to the first date available (15 or 90 days ago)
      const date = this.directoryInsightsPremium
        ? quickPicksOptions.ninetyDays
        : quickPicksOptions.fifteenDays;
      this.setQuickPickDate(date);

      this.setFilter({
        field: eventFields.service,
        value: ['password_manager'],
      });

      this.dropdownFilters.forEach((filter => this.setFilter(filter)));

      Util.redirect('#/insights');
    },
  },
};
</script>

  <style scoped>
  .activityLogTable {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  </style>
